export namespace ECOMMERCE_CONFIGURATION_TYPE {
    export const QUOTE_CART = "quote-cart"
    export const QUOTE_CART_SETTING = "quote-cart-setting"
    export const QUOTE_CART_STYLE = "quote-cart-style"
    export const FLOATING_QUOTE_BUTTON = "floating-quote-button"
    export const FLOATING_QUOTE_BUTTON_SETTING = "floating-quote-button-setting"
    export const FLOATING_QUOTE_BUTTON_STYLE = "floating-quote-button-style"
    export const ADD_TO_QUOTE_BUTTON = "add-to-quote-button"
    export const ADD_TO_QUOTE_BUTTON_SETTING = "add-to-quote-button-setting"
    export const ADD_TO_QUOTE_BUTTON_STYLE = "add-to-quote-button-style"
    export const QUOTE_FORM = "quote-form"
    export const QUOTE_FORM_SETTING = "quote-form-setting"
    export const QUOTE_FORM_STYLE = "quote-form-style"
    export const RULES = "rules"
}

export namespace BUTTON_POSITION {
    export const TOP_RIGHT = "qm_floating_button_position_top_right"
    export const TOP_LEFT = "qm_floating_button_position_top_left"
    export const MID_RIGHT = "qm_floating_button_position_mid_right"
    export const MID_LEFT = "qm_floating_button_position_mid_left"
    export const BOTTOM_RIGHT = "qm_floating_button_position_bottom_right"
    export const BOTTOM_LEFT = "qm_floating_button_position_bottom_left"
}

export namespace CART_TO_USE {
    export const MAIN_CART = "main_cart"
    export const QUOTE_CART = "quote_cart"
}

export namespace OPEN_CART_ONCLICK_OPTION {
    export const NEVER = "never_open"
    export const ALWAYS = "always_open"
    export const PRODUCT_PAGE_ONLY = "product_page_only"
    export const COLLECTION_PAGE_ONLY = "collection_page_only"
}

export namespace INPUT_LABEL_POSITION {
    export const TOP_POSITION = "top"
    export const BOTTOM_POSITION = "bottom"
    export const HIDDEN_POSITION = "hidden"

}

export type ECOMMERCE_CONFIGURATION_TYPE = typeof ECOMMERCE_CONFIGURATION_TYPE[keyof typeof ECOMMERCE_CONFIGURATION_TYPE];
export type BUTTON_POSITION = typeof BUTTON_POSITION[keyof typeof BUTTON_POSITION];
export type CART_TO_USE = typeof CART_TO_USE[keyof typeof CART_TO_USE];
export type INPUT_LABEL_POSITION = typeof INPUT_LABEL_POSITION[keyof typeof INPUT_LABEL_POSITION];


export const BUTTON_POSITION_OPTIONS = [
    BUTTON_POSITION.TOP_RIGHT,
    BUTTON_POSITION.TOP_LEFT,
    BUTTON_POSITION.MID_RIGHT,
    BUTTON_POSITION.MID_LEFT,
    BUTTON_POSITION.BOTTOM_RIGHT,
    BUTTON_POSITION.BOTTOM_LEFT,
]

export const OPEN_CART_ONCLICK_OPTIONS = [
    OPEN_CART_ONCLICK_OPTION.ALWAYS,
    OPEN_CART_ONCLICK_OPTION.NEVER,
    //todo uncomment once collection page logic is implemented
    // OPEN_CART_ONCLICK_OPTION.COLLECTION_PAGE_ONLY,
    OPEN_CART_ONCLICK_OPTION.PRODUCT_PAGE_ONLY,
]

export const CART_TO_USE_OPTIONS = [
    CART_TO_USE.MAIN_CART,
    CART_TO_USE.QUOTE_CART,
]

export const INPUT_LABEL_POSITION_OPTIONS = [
    INPUT_LABEL_POSITION.TOP_POSITION,
    INPUT_LABEL_POSITION.BOTTOM_POSITION,
    INPUT_LABEL_POSITION.HIDDEN_POSITION,

]

export const STYLE_INPUT_MAPPING = {
    buttonPosition: "select",
    openCartOnClickOption: "select",
    cartToUse: "select",
    buttonColor: "color",
    buttonLabelColor: "color",
    labelPosition: "select",
}


// WEBPACK FOOTER //
// ./src/state/ecommerce-configuration/EcommerceTypes.ts